export type LabelCodeType = 'km' | 'ka_box' | 'ka_pallet'

export interface LabelTemplateSummary {
  template_id: string
  name: string
  filename: string
  type?: string
  width: number
  height: number
  for_km: boolean
  for_ka_box: boolean
  for_ka_pallet: boolean
  is_default_km: boolean
  is_default_ka_box: boolean
  is_default_ka_pallet: boolean
}

export interface LabelTemplateAssignment {
  for_km: boolean
  for_ka_box: boolean
  for_ka_pallet: boolean
  is_default_km: boolean
  is_default_ka_box: boolean
  is_default_ka_pallet: boolean
}

export const LABEL_CODE_TYPE_LABELS: Record<LabelCodeType, string> = {
  km: 'КМ',
  ka_box: 'КА упаковки',
  ka_pallet: 'КА паллеты',
}
